import { redirect } from "@tanstack/react-router";
import { authClient } from "@/lib/auth-client";

// ── Frontend session guards (used inside TanStack Router beforeLoad) ──────────

export async function requireAuth() {
  const { data, error } = await authClient.getSession();
  if (data) return data;
  // A transient get-session failure (network blip, 5xx, ECS task cycling) returns no
  // data WITH an error set — distinct from a clean "no session" (data null, error
  // null). Redirecting to /login on the former masquerades as a sign-out on refresh,
  // so we rethrow and let the ErrorBoundary render a retry instead of logging the
  // user out. Only a genuine absence of a session sends them to /login.
  if (error) {
    throw new Error(error.message ?? "Could not verify your session. Please try again.");
  }
  throw redirect({ to: "/login" });
}

/** CEO and RM have admin-plugin privileges (impersonate, user management, settings). */
export async function requireAdmin() {
  const session = await requireAuth();
  const role = session.user.role;
  if (role !== "CEO" && role !== "RM") throw redirect({ to: "/dashboard" });
  return session;
}

// Server-side capability enforcement (Actor, ScopeCheckContext, requireCapability)
// now lives in src/lib/permissions-server.ts to keep the frontend bundle clean of
// Postgres / Drizzle imports.
